<script setup>
import { ref, onMounted, defineProps, onUnmounted } from "vue";
import { RouterLink } from "vue-router";
import { EyeIcon } from "@heroicons/vue/24/solid";
import csvIcon from "@/assets/csvIcon.svg";
import ListDetail from "./ListDetail.vue";
import { getList } from "@/services/lists";

const isDropdownOpen = ref(false);

const selectedListDetail = ref(null);
const showListDetail = ref(false);
const offcanvasListDetail = ref(null);

const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
});

console.log(props.data);

const lists = ref([]);

function formatDate(dateString) {
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  const date = new Date(dateString);
  return date.toLocaleDateString("es-ES", options);
}

const loadLists = async () => {
  const clientId = localStorage.getItem("cx");
  if (!clientId) {
    console.error("Client ID not found in localStorage");
    return;
  }
  try {
    const response = await getList(clientId);
    console.log("Datos obtenidos de getList:", response.data);
    lists.value = response.data;
  } catch (error) {
    console.error("Error al obtener la lista:", error);
  }
};

/* Click fuera del dropdown */
onMounted(() => {
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".dropdown")) {
      isDropdownOpen.value = false;
    }
  });

  loadLists();
});

function toggleListDetail(list) {
  showListDetail.value = !showListDetail.value;

  selectedListDetail.value = list;
  console.log("Selected List:", selectedListDetail.value);

  setTimeout(() => {
    showListDetail.value = true;
  }, 0);
}

const closeOffcanvas = () => {
  showListDetail.value = false;
};
const handleEscape = (event) => {
  if (event.key === "Escape") {
    closeOffcanvas();
  }
};
onMounted(() => {
  window.addEventListener("keydown", handleEscape);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEscape);
});
</script>
<template>
  <div class="rounded-lg">
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th>Nombre de la Fuente</th>
          <th class="truncate-text">Descripción</th>
          <th>Estatus</th>
          <th>Actualización</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in lists" :key="item.id">
          <td>
            <div class="d-flex justify-content-center">
              <img
                :src="csvIcon"
                alt="csv archive"
                class="text-blue-500 d-inline-flex justify-content-center"
                style="
                  color: #517fa4;
                  width: 25px;
                  height: 25px;
                  margin-right: 5px;
                "
              />
            </div>
          </td>
          <td>
            <RouterLink :to="{ name: 'DetailScheme' }" class="globals-a">
              {{ item.name }}
            </RouterLink>
          </td>
          <td class="truncate-text">
            {{ item.description }}
          </td>
          <td>{{ item.status }}</td>
          <td>{{ formatDate(item.date) }}</td>
          <td class="d-flex gap-3" style="margin-top: 3px; border-bottom: none">
            <button
              class="buttons-group"
              @click="toggleListDetail(item)"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasListDetail"
              aria-controls="offcanvasListDetail"
            >
              <EyeIcon
                class="text-blue-500 d-flex justify-content-center"
                style="color: #517fa4; width: 20px; height: 20px"
              ></EyeIcon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div
    class="offcanvas offcanvas-end"
    style="width: 45%"
    data-bs-scroll="true"
    tabindex="-1"
    id="offcanvasListDetail"
    aria-labelledby="offcanvasListDetailLabel"
    ref="offcanvasListDetail"
  >
    <div class="offcanvas-header">
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body" v-if="showListDetail">
      <ListDetail
        :listDetail="selectedListDetail"
        @closeOffcanvas="closeOffcanvas"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.buttons-group {
  border: none;
  background: transparent;
  cursor: pointer;
}
.delete:hover {
  background-color: $gradient-color-01;
}
.rounded-lg {
  border-radius: 10px;
  overflow: hidden;
}
.table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid $seven-color;
  text-transform: capitalize;
}

th {
  background-color: $seven-color;
  color: $primary-color;
}
.truncate-text {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
